export class ListQueryExecutionsRequestFiltersCreatedAt {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fromTime",
            "baseName": "fromTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "toTime",
            "baseName": "toTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsRequestFiltersCreatedAt.attributeTypeMap;
    }
    constructor() {
    }
}
